import * as i0 from '@angular/core';
import { Input, Component, ViewEncapsulation, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@engineering11/ui-lib/e11-directives';
import { E11DirectivesModule } from '@engineering11/ui-lib/e11-directives';

// export type Color = '' | 'primary' | 'primary-accent' | 'secondary'
class E11IconLoaderComponent {
    constructor() {
        this.size = 'md';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11IconLoaderComponent, isStandalone: true, selector: "e11-icon-loader", inputs: { classOverrides: "classOverrides", size: "size" }, ngImport: i0, template: `
    <svg
      class="e11-icon-loader e11-animate-spin e11-icon-size-{{ size }} {{ classOverrides }}"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="e11-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="e11-opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  `, isInline: true, styles: [".e11-icon-loader.e11-icon-size-sm{height:1rem;width:1rem}.e11-icon-loader.e11-icon-size-md{height:1.25rem;width:1.25rem}.e11-icon-loader.e11-icon-size-lg{height:1.75rem;width:1.75rem}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-icon-loader', standalone: true, template: `
    <svg
      class="e11-icon-loader e11-animate-spin e11-icon-size-{{ size }} {{ classOverrides }}"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="e11-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="e11-opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  `, styles: [".e11-icon-loader.e11-icon-size-sm{height:1rem;width:1rem}.e11-icon-loader.e11-icon-size-md{height:1.25rem;width:1.25rem}.e11-icon-loader.e11-icon-size-lg{height:1.75rem;width:1.75rem}\n"] }]
        }], ctorParameters: () => [], propDecorators: { classOverrides: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class E11IconBellComponent {
    constructor() { }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconBellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11IconBellComponent, selector: "e11-icon-bell", inputs: { classOverrides: "classOverrides" }, ngImport: i0, template: `
    <svg
      class="e11-h-6 e11-w-6 {{ classOverrides }}"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconBellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-icon-bell',
                    template: `
    <svg
      class="e11-h-6 e11-w-6 {{ classOverrides }}"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { classOverrides: [{
                type: Input
            }] } });

class E11IconEnvelopeComponent {
    constructor() {
        // Title
        this.titleText = '';
        this.titleTextPosition = 'top';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconEnvelopeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11IconEnvelopeComponent, selector: "e11-icon-envelope", inputs: { classOverrides: "classOverrides", titleText: "titleText", titleTextPosition: "titleTextPosition" }, ngImport: i0, template: `
    <div class="e11-relative e11-inline-block" [e11title]="titleText" [e11titlePosition]="titleTextPosition">
      <svg xmlns="http://www.w3.org/2000/svg" class="e11-h-6 e11-w-6 {{ classOverrides }}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.E11TitleDirective, selector: "[e11title]", inputs: ["e11title", "e11titlePosition", "delay"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconEnvelopeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-icon-envelope',
                    template: `
    <div class="e11-relative e11-inline-block" [e11title]="titleText" [e11titlePosition]="titleTextPosition">
      <svg xmlns="http://www.w3.org/2000/svg" class="e11-h-6 e11-w-6 {{ classOverrides }}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    </div>
  `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [], propDecorators: { classOverrides: [{
                type: Input
            }], titleText: [{
                type: Input
            }], titleTextPosition: [{
                type: Input
            }] } });

class E11IconInboxComponent {
    constructor() { }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconInboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11IconInboxComponent, selector: "e11-icon-inbox", inputs: { classOverrides: "classOverrides" }, ngImport: i0, template: `
    <svg xmlns="http://www.w3.org/2000/svg" class="e11-h-6 e11-w-6 {{ classOverrides }}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
      />
    </svg>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconInboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-icon-inbox',
                    template: `
    <svg xmlns="http://www.w3.org/2000/svg" class="e11-h-6 e11-w-6 {{ classOverrides }}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
      />
    </svg>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { classOverrides: [{
                type: Input
            }] } });

class E11IconErrorComponent {
    constructor() { }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11IconErrorComponent, selector: "e11-icon-error", inputs: { classOverrides: "classOverrides" }, ngImport: i0, template: `
    <svg
      class="e11-h-5 e11-w-5 e11-text-skin-error {{ classOverrides }}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd"
      />
    </svg>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconErrorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-icon-error',
                    template: `
    <svg
      class="e11-h-5 e11-w-5 e11-text-skin-error {{ classOverrides }}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd"
      />
    </svg>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { classOverrides: [{
                type: Input
            }] } });

const declareExportComponents = [E11IconBellComponent, E11IconEnvelopeComponent, E11IconInboxComponent, E11IconErrorComponent];
class E11IconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11IconModule, declarations: [E11IconBellComponent, E11IconEnvelopeComponent, E11IconInboxComponent, E11IconErrorComponent], imports: [CommonModule, E11DirectivesModule, E11IconLoaderComponent], exports: [E11IconBellComponent, E11IconEnvelopeComponent, E11IconInboxComponent, E11IconErrorComponent, E11IconLoaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconModule, imports: [CommonModule, E11DirectivesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11IconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...declareExportComponents],
                    imports: [CommonModule, E11DirectivesModule, E11IconLoaderComponent],
                    exports: [...declareExportComponents, E11IconLoaderComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11IconBellComponent, E11IconEnvelopeComponent, E11IconErrorComponent, E11IconInboxComponent, E11IconLoaderComponent, E11IconModule };
